<template>
  <v-dialog v-model="sessionOut" persistent height="500" width="500">
    <loading
      :active="isload"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <v-card>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex justify-center">
          <img
            class="text-center"
            src="@/assets/sessionout.png"
            height="250"
            width="300"
            contain
          />
        </v-col>
        <v-col>
          <h3 class="text-center">Session Expired</h3>
          <p class="text-center">
            Your session has timed out. Please login again to continue accessing
            the application.
          </p>
          <p class="text-center">
            <v-btn depressed @click="logout" color="primary">Login Again</v-btn>
          </p>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "vue-loading-overlay";
import alerts from "@/mixins/alerts";
import store from "../store/index";
export default {
  name: "imageViewer",
  mixins: [alerts],
  props: { sessionOut: Boolean },
  data() {
    return {
      isload: false,
    };
  },
  components: {
    Loading,
  },
  methods: {
    async logout() {
      this.isload = true;
      try {
        store.commit("setSessionOut", false);
        sessionStorage.clear();
        this.isload = false;
        this.$router.replace({ name: "Login" });
      } catch (e) {
        this.isload = false;
        this.showAlertError("Something went wrong please try again later.");
        console.error(e);
      }
    },
  },
};
</script>

<style></style>
